module.exports = __webpack_public_path__ + "img/ticket_bg.3a4b19fc.png";